import * as React from 'react';
import { AnimatePresence, motion } from 'motion/react';
import styled from '@emotion/styled';

export interface AnimatePageWidgetProps {
  slide: boolean;
}

export const AnimatePageWidget: React.FC<React.PropsWithChildren<AnimatePageWidgetProps>> = (props) => {
  if (props.slide) {
    return (
      <AnimatePresence>
        <S.Page
          key="modal"
          initial={{ transform: 'translateX(-50px)', opacity: 0 }}
          animate={{ transform: 'translateX(0)', opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          {props.children}
        </S.Page>
      </AnimatePresence>
    );
  }

  return (
    <AnimatePresence>
      <S.Page key="modal" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
        {props.children}
      </S.Page>
    </AnimatePresence>
  );
};

namespace S {
  export const Page = styled(motion.div)`
    height: 100%;
    min-height: 0;
    overflow: auto;
  `;
}
